function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 5.456a1.5 1.5 0 011.5-1.5h15a1.5 1.5 0 011.5 1.5v1.5h-3v3h3v6h-3v3h3v1.5a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 01-1.5-1.5v-15zm3 1.5h3v3H6v-3zm3 9H6v3h3v-3zm3-9h3v3h-3v-3zm3 9h-3v3h3v-3z",
  fill: "#81858D"
});

var SvgContent = function SvgContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDUuNDU2MDVDMyA0LjYyNzYzIDMuNjcxNTcgMy45NTYwNSA0LjUgMy45NTYwNUgxOS41QzIwLjMyODQgMy45NTYwNSAyMSA0LjYyNzYzIDIxIDUuNDU2MDVWNi45NTYwNUgxOFY5Ljk1NjA1SDIxVjE1Ljk1NjFIMThWMTguOTU2MUgyMVYyMC40NTYxQzIxIDIxLjI4NDUgMjAuMzI4NCAyMS45NTYxIDE5LjUgMjEuOTU2MUg0LjVDMy42NzE1NyAyMS45NTYxIDMgMjEuMjg0NSAzIDIwLjQ1NjFWNS40NTYwNVpNNiA2Ljk1NjA1SDlWOS45NTYwNUg2VjYuOTU2MDVaTTkgMTUuOTU2MUg2VjE4Ljk1NjFIOVYxNS45NTYxWk0xMiA2Ljk1NjA1SDE1VjkuOTU2MDVIMTJWNi45NTYwNVpNMTUgMTUuOTU2MUgxMlYxOC45NTYxSDE1VjE1Ljk1NjFaIiBmaWxsPSIjODE4NThEIi8+Cjwvc3ZnPg==";
export { SvgContent as ReactComponent };